interface EsperaResultadoEnvio {
  resolve: (resultado: any) => void;
  reject: (erro: Error) => void;
  timeoutId: any;
}

export class ResultadoEnvioWhatsapp {
  private pendentes: { [id: string]: EsperaResultadoEnvio } = {};

  constructor(private timeoutMs: number = 130000) {}

  aguarde(idMensagem: string): Promise<any> {
    const id = String(idMensagem || '');

    if (!id) {
      return Promise.reject(new Error('Identificador da mensagem não informado.'));
    }

    if (this.pendentes[id]) {
      return Promise.reject(new Error('Já existe um envio aguardando este identificador.'));
    }

    return new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        delete this.pendentes[id];
        reject(new Error('Tempo esgotado ao aguardar o envio pelo WhatsApp.'));
      }, this.timeoutMs);

      this.pendentes[id] = { resolve, reject, timeoutId };
    });
  }

  conclua(idMensagem: string, resultado: any): boolean {
    const id = String(idMensagem || '');
    const pendente = this.pendentes[id];

    if (!pendente) {
      return false;
    }

    clearTimeout(pendente.timeoutId);
    delete this.pendentes[id];
    pendente.resolve(resultado);
    return true;
  }
}
